import { Component, Input } from '@angular/core';
import { ApexAxisChartSeries, ApexChart, ApexDataLabels, ApexPlotOptions, ApexYAxis, ApexLegend, ApexStroke, ApexXAxis, ApexFill, ApexTooltip, ApexTitleSubtitle } from "ng-apexcharts";
import { Helper } from '../../utilities/classes/helper.class';

@Component({
  selector: 'app-acc-barchart',
  templateUrl: './acc-barchart.component.html',
  styleUrls: ['./acc-barchart.component.scss']
})
export class AccBarchartComponent {

  @Input('properties') public properties: BarChartOptions = this.defaultBarChartOptions();
  constructor() { }

  public defaultBarChartOptions(): BarChartOptions {
    return Helper.chartOptions.bar;
  }

}

export interface BarChartOptions {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  fill: ApexFill;
  stroke: ApexStroke;
  legend: ApexLegend;
  title: ApexTitleSubtitle;
  colors: string[];
  tooltip: ApexTooltip;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
}
